import { defineModuleGlobal, defineModuleMap } from 'util/moduledata';

export type EditorialChannel = {
    from: string;
    key: string;
    name: string;
    email?: string;
    photoUrl: string;
    time: number;
    isDefault?: boolean;
};

export type ChannelInstanceMappingEntry = {
    key: string;
    from: string;
    instanceKey: string;
    structureKey: string;
    concatenatedKey: string;
    time: number;
    updated?: number;
    channelKey: string;
};

export type ChannelMemberInfo = {
    memberEmails: string[];
};

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'channeltypes'
export const moduleMapChannel = defineModuleMap<EditorialChannel>('PUBLIC', 'channel', 'all');

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'channeltypes'
export const moduleMapInstanceToChannel = defineModuleMap<ChannelInstanceMappingEntry>('PUBLIC', 'channel', 'instanceToChannel');

// TODO: Define a type for this
// eslint-disable-next-line module-data-owner -- FIXME: use module name 'channeltypes'
export const moduleMapChannelToInstance = defineModuleMap<any>('PUBLIC', 'channel', 'channelToInstance');

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'channeltypes'
export const moduleUserGlobalChannel = defineModuleGlobal<string>('USER_GLOBAL', 'channel', 'currentChannel');
